(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[466],{

/***/ 45892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _form_GeneralSearchPanel; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./src/components/_form/Field/index.tsx
var Field = __webpack_require__(50509);
// EXTERNAL MODULE: ./src/elements/Warning/index.tsx
var Warning = __webpack_require__(34155);
// EXTERNAL MODULE: ./src/hooks/useForm.tsx + 4 modules
var useForm = __webpack_require__(74766);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
;// CONCATENATED MODULE: ./src/components/_form/GeneralSearchPanel/schema.ts

var schema = es/* object */.Ry().shape({
    searchQuery: es/* string */.Z_(),
    customQuestionnaire: es/* boolean */.O7()
});
var initialValues = {
    searchQuery: '',
    customQuestionnaire: false
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(28440);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(44858);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(42359);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Form.js + 15 modules
var Form = __webpack_require__(28268);
// EXTERNAL MODULE: ./src/components/_form/form.module.scss
var form_module = __webpack_require__(55644);
var form_module_default = /*#__PURE__*/__webpack_require__.n(form_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/bootstrap-icons@1.8.1/node_modules/bootstrap-icons/font/bootstrap-icons.css
var bootstrap_icons = __webpack_require__(26219);
// EXTERNAL MODULE: ./src/components/_form/GeneralSearchPanel/generalSearchPanel.module.scss
var generalSearchPanel_module = __webpack_require__(4924);
var generalSearchPanel_module_default = /*#__PURE__*/__webpack_require__.n(generalSearchPanel_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-content-loader@6.2.0_react@17.0.2/node_modules/react-content-loader/dist/react-content-loader.es.js
var react_content_loader_es = __webpack_require__(16629);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(95601);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/consts/paths/api/usage/index.ts
var usage = __webpack_require__(91070);
// EXTERNAL MODULE: ./src/consts/sharedQueryKeys.ts
var sharedQueryKeys = __webpack_require__(37109);
// EXTERNAL MODULE: ./src/hooks/useApi.ts
var useApi = __webpack_require__(7920);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88349);
;// CONCATENATED MODULE: ./src/hooks/useUsage/index.ts





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useUsage() {
    var api = (0,useApi/* default */.Z)();
    var ref = (0,react_query_es.useQuery)([
        sharedQueryKeys/* usageBaseQueryKey */.Rq
    ], _asyncToGenerator(runtime_default().mark(function _callee() {
        var result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get(usage/* default */.Z);
                case 2:
                    result = _ctx.sent;
                    return _ctx.abrupt("return", result === null || result === void 0 ? void 0 : result.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))), usageData = ref.data, error = ref.error, isLoading = ref.isLoading;
    return {
        usageData: usageData,
        error: error,
        isLoading: isLoading
    };
}
/* harmony default export */ var hooks_useUsage = (useUsage);

// EXTERNAL MODULE: ./src/components/_form/TypeaheadWithApiCall/index.tsx
var TypeaheadWithApiCall = __webpack_require__(69001);
// EXTERNAL MODULE: ./src/consts/paths/api/items/getItems/index.ts
var getItems = __webpack_require__(41999);
// EXTERNAL MODULE: ./src/consts/paths/api/questionnaires/questionnairesPath.ts
var questionnairesPath = __webpack_require__(61680);
// EXTERNAL MODULE: ./src/elements/CustomIcon/index.tsx
var CustomIcon = __webpack_require__(61592);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/router.js
var next_router = __webpack_require__(63359);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/index.js + 87 modules
var react_bootstrap_typeahead_es = __webpack_require__(3078);
// EXTERNAL MODULE: ./src/_types/api/questionnaires/QuestionnaireType.ts
var QuestionnaireType = __webpack_require__(49676);
// EXTERNAL MODULE: ./src/components/_form/GeneralSearchPanel/SearchResultDropdown/searchResultDropdown.module.scss
var searchResultDropdown_module = __webpack_require__(66346);
var searchResultDropdown_module_default = /*#__PURE__*/__webpack_require__.n(searchResultDropdown_module);
;// CONCATENATED MODULE: ./src/components/_form/GeneralSearchPanel/SearchResultDropdown/index.tsx








var SearchResultDropdown = function(param) {
    var option = param.option, text = param.menuProps.text;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    if (!option) {
        return null;
    }
    var object = option.object;
    var code = object.code, description = object.description, id = object.id, type = object.type;
    var isGrayQuestionnaire = (ref = object) === null || ref === void 0 ? void 0 : ref.isCustom;
    var iconType = isGrayQuestionnaire ? QuestionnaireType/* default.PREVIOUS */.Z.PREVIOUS : type;
    var onClickProxy = function() {
        void router.push({
            pathname: option.type === 'item' ? getItems/* default */.Z : questionnairesPath/* default */.ZP,
            query: {
                id: id
            }
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: onClickProxy,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIcon/* default */.Z, {
                extraClassName: (searchResultDropdown_module_default()).option,
                iconType: iconType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_bootstrap_typeahead_es/* Highlighter */.oP, {
                        search: text,
                        children: code ? "".concat(code, " - ") : ''
                    }),
                    // Items
                    option.type === 'item' ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_bootstrap_typeahead_es/* Highlighter */.oP, {
                                search: text,
                                children: description ? "".concat(description, " - ") : ''
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_bootstrap_typeahead_es/* Highlighter */.oP, {
                                search: text,
                                children: 'preferredWording' in object && object.preferredWording || ''
                            })
                        ]
                    }) : // Questionnaires
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_bootstrap_typeahead_es/* Highlighter */.oP, {
                        search: text,
                        children: ((ref1 = object) === null || ref1 === void 0 ? void 0 : ref1.name) || ''
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var GeneralSearchPanel_SearchResultDropdown = (SearchResultDropdown);

// EXTERNAL MODULE: ./src/consts/itemDetails.ts
var itemDetails = __webpack_require__(40332);
;// CONCATENATED MODULE: ./src/components/_form/GeneralSearchPanel/functions/getFilterPredicate.ts
/**
 * Returns the condition against which a Typeahead filter will be applied for each search result item
 * @param labelPart     Search result item label part that will be tested
 * @param text          Text entered by user in Typeahead field component
 * @returns             Condition to be checked for Typeahead's filterBy prop (ie a boolean)
 */ var getFilterPredicate = function(labelPart, text) {
    return typeof labelPart === 'string' ? labelPart.toLowerCase().indexOf(text.toLowerCase()) !== -1 : false;
};
/* harmony default export */ var functions_getFilterPredicate = (getFilterPredicate);

;// CONCATENATED MODULE: ./src/components/_form/GeneralSearchPanel/functions/getOptionLabel.ts
/**
 * Formats given search result item to have a label that starts with the item code
 * @param code    Search result item code (eg: "Q676")
 * @param label   Search result item label to be used for the label
 * @returns       Formatted label
 */ var getOptionLabel = function(code, label) {
    return "".concat(code ? "".concat(code, " - ") : '').concat(label || '');
};
/* harmony default export */ var functions_getOptionLabel = (getOptionLabel);

;// CONCATENATED MODULE: ./src/components/_form/GeneralSearchPanel/index.tsx




















function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var GeneralSearchPanel = function(param) {
    var _containerStyles = param.containerStyles, containerStyles = _containerStyles === void 0 ? "".concat((generalSearchPanel_module_default())["searchPanel--big"], " pt-4 pb-5") : _containerStyles, _isTitleDisplayed = param.isTitleDisplayed, isTitleDisplayed = _isTitleDisplayed === void 0 ? true : _isTitleDisplayed, _searchFieldColSizes = param.searchFieldColSizes, searchFieldColSizes = _searchFieldColSizes === void 0 ? {
        sm: 10,
        md: 8,
        lg: 6
    } : _searchFieldColSizes, _isSmall = param.isSmall, isSmall = _isSmall === void 0 ? false : _isSmall;
    var ref8;
    /*
        Hooks
    */ var router = (0,next_router.useRouter)();
    var ref1 = hooks_useUsage(), usageData = ref1.usageData, isLoading = ref1.isLoading;
    var ref2 = (0,useForm/* default */.Z)({
        schema: schema,
        onSubmit: function() {
            return Promise.resolve(null);
        },
        defaultValues: initialValues
    }), register = ref2.register, control = ref2.control, warningMessage = ref2.warningMessage, errors = ref2.formState.errors, setValue = ref2.setValue, watch = ref2.watch;
    /*
        Variables/constants
    */ var kind = watch('customQuestionnaire');
    // ! Note: this follows the same logic as what we have on the AS-IS except the "community" path is
    // replaced here by a "kind" query parameter so it matches the query param used in the GET /search
    // endpoint ("kind")
    var customQuestionnairesParam = kind ? undefined : {
        kind: 'Official'
    };
    /*
        Event handlers
    */ var onSelectProxy = function(query) {
        void router.push({
            pathname: '/search',
            query: kind ? {
                q: query
            } : _objectSpread({
                q: query
            }, customQuestionnairesParam)
        });
    };
    var handleKeypress = function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            var target = e.target;
            onSelectProxy(target.value);
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: containerStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            className: (generalSearchPanel_module_default()).searchPanel,
            children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_content_loader_es/* Code */.EK, {}) : usageData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isTitleDisplayed && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: (generalSearchPanel_module_default()).searchPanelTitle,
                                children: [
                                    usageData.numberOfQuestionnaires,
                                    " questionnaires,",
                                    ' ',
                                    usageData.numberOfQuestionItems,
                                    " questions"
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        className: isSmall ? (generalSearchPanel_module_default()).smallSearchWrapper : (generalSearchPanel_module_default()).centred,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            sm: searchFieldColSizes.sm,
                            md: searchFieldColSizes.md,
                            lg: searchFieldColSizes.lg,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                                    show: !!warningMessage,
                                    text: warningMessage
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                                    noValidate: true,
                                    className: "".concat((form_module_default()).form, " px-0 pt-0 pb-2"),
                                    onKeyDown: handleKeypress,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field/* default */.Z, {
                                            id: "searchQuery",
                                            feedback: errors.searchQuery,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "bi bi-search ".concat((generalSearchPanel_module_default()).searchIcon)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeaheadWithApiCall/* default */.Z, {
                                                    // Perform 3 calls at once (ideally should be handled in the backend)
                                                    apiConfig: [
                                                        {
                                                            url: "".concat(getItems/* default */.Z, "/").concat(itemDetails/* KEYWORDS */.Pb, "/search"),
                                                            maxResults: 3,
                                                            params: customQuestionnairesParam
                                                        },
                                                        {
                                                            url: "".concat(getItems/* default */.Z, "/").concat(itemDetails/* ICDCODES */.gJ, "/search"),
                                                            maxResults: 3,
                                                            params: customQuestionnairesParam
                                                        },
                                                        {
                                                            url: '/search',
                                                            maxResults: 5,
                                                            params: customQuestionnairesParam
                                                        }, 
                                                    ],
                                                    control: control,
                                                    error: (ref8 = errors.searchQuery) === null || ref8 === void 0 ? void 0 : ref8.message,
                                                    filterBy: function(option, props) {
                                                        var ref, ref3, ref4, ref5, ref6, ref7;
                                                        return functions_getFilterPredicate((ref = option) === null || ref === void 0 ? void 0 : (ref3 = ref.object) === null || ref3 === void 0 ? void 0 : ref3.preferredWording, props.text) || functions_getFilterPredicate((ref4 = option) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.object) === null || ref5 === void 0 ? void 0 : ref5.description, props.text) || functions_getFilterPredicate((ref6 = option) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.object) === null || ref7 === void 0 ? void 0 : ref7.code, props.text) || option;
                                                    },
                                                    infoText: "",
                                                    isInvalid: !!errors.searchQuery,
                                                    labelKey: function(option) {
                                                        var ref, ref9, ref10, ref11;
                                                        return typeof option === 'string' ? option : option.type === 'item' ? functions_getOptionLabel((ref = option.object) === null || ref === void 0 ? void 0 : ref.code, (ref9 = option.object) === null || ref9 === void 0 ? void 0 : ref9.description) : functions_getOptionLabel((ref10 = option.object) === null || ref10 === void 0 ? void 0 : ref10.code, (ref11 = option.object) === null || ref11 === void 0 ? void 0 : ref11.name);
                                                    },
                                                    multiple: false,
                                                    name: "searchQuery",
                                                    placeholder: "search the item library...",
                                                    className: (generalSearchPanel_module_default()).typeahead,
                                                    renderMenuItemChildren: function(option, menuProps) {
                                                        // Search queries that are not linked to any particular items
                                                        return typeof option === 'string' ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (searchResultDropdown_module_default()).optionText,
                                                            onClick: function() {
                                                                return onSelectProxy(option);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "bi bi-search text-secondary ".concat((generalSearchPanel_module_default()).resultsSearchIcon)
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_bootstrap_typeahead_es/* Highlighter */.oP, {
                                                                    search: menuProps.text,
                                                                    children: option
                                                                })
                                                            ]
                                                        }) : // Items
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneralSearchPanel_SearchResultDropdown, {
                                                            option: option,
                                                            menuProps: menuProps
                                                        });
                                                    },
                                                    setValue: setValue
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                            id: "customQuestionnaire",
                                            feedback: errors.customQuestionnaire,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, _objectSpread({
                                                className: (generalSearchPanel_module_default()).searchPanelCheckbox,
                                                label: "Include custom questionnaires from the community",
                                                type: "checkbox"
                                            }, register('customQuestionnaire'), {
                                                onChange: function(value) {
                                                    return setValue('customQuestionnaire', value.target.checked);
                                                }
                                            }))
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var _form_GeneralSearchPanel = (GeneralSearchPanel);


/***/ }),

/***/ 61592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _customIcon_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22338);
/* harmony import */ var _customIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_customIcon_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var CustomIcon = function(_param) /*#__PURE__*/ {
    var _extraClassName = _param.extraClassName, extraClassName = _extraClassName === void 0 ? '' : _extraClassName, iconType = _param.iconType, props = _objectWithoutProperties(_param, [
        "extraClassName",
        "iconType"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", _objectSpread({
        className: "".concat(extraClassName, " ").concat((_customIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default().icon), " ").concat((_customIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[iconType])
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomIcon);


/***/ }),

/***/ 66346:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"option":"searchResultDropdown_option__qZlbU","optionText":"searchResultDropdown_optionText__O84Gj"};

/***/ }),

/***/ 4924:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchPanel":"generalSearchPanel_searchPanel__KaQYo","searchPanel--small":"generalSearchPanel_searchPanel--small__PQ5o1","searchPanel--big":"generalSearchPanel_searchPanel--big__unon1","centred":"generalSearchPanel_centred__YuoiK","smallSearchWrapper":"generalSearchPanel_smallSearchWrapper__YyeV6","searchPanelTitle":"generalSearchPanel_searchPanelTitle__ttNOQ","resultsSearchIcon":"generalSearchPanel_resultsSearchIcon__nHbVf","searchPanelCheckbox":"generalSearchPanel_searchPanelCheckbox__6vPif","typeahead":"generalSearchPanel_typeahead__UDM0m","searchIcon":"generalSearchPanel_searchIcon__O4FhV"};

/***/ }),

/***/ 55644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"form_formWrapper__jfTN5","form":"form_form__gsnZH","formTitle":"form_formTitle__n8VjK","formFieldLabel":"form_formFieldLabel__A6APK","formInput":"form_formInput__Y2M1x","formLinks":"form_formLinks__ezm6E"};

/***/ }),

/***/ 22338:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon":"customIcon_icon__5v8Pm","question":"customIcon_question__Ae3rG","condition":"customIcon_condition__t_aSl","instructions":"customIcon_instructions__nwvwn","timeScale":"customIcon_timeScale__8jMWW","responseScale":"customIcon_responseScale__c3Fyc","symptomScale":"customIcon_symptomScale__e9YYp","questionnaire":"customIcon_questionnaire__66KvY","core":"customIcon_core__Rg4Ow","module":"customIcon_module__0MtuL","standalone":"customIcon_standalone__TgjpB","previous":"customIcon_previous__ns9DS","cat":"customIcon_cat__bBgYu","catshort":"customIcon_catshort__RhPJe","shortform":"customIcon_shortform__4MIYX","itemlist":"customIcon_itemlist___k814","draft":"customIcon_draft__Uee6Q","male":"customIcon_male__mBfda","female":"customIcon_female__mS7lo"};

/***/ })

}]);